import axios from 'axios';
import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';

const RASKEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6zL1TeRVpAkPlotzM6q6ETlpI25nPXKE539jJ6Ax/jF1H5CZGuwJ9KqvFtwK2YMZUIT5VdNgs6yetaYu1aPpx54OdYEtG/+tlZIDg8hT5Z22adVLOJ1aKlLotuiyh08HDBNHqhjhzdDhZONiSaZRNEuDEBlAMJCXjx1kveJVZOwIDAQAB';

export const request_post = (url, data, config = {}) => {
  return axios.post(url, data, config).then((res) => {
    if (!res.data.code) return Promise.resolve(res.data);
    return Promise.reject(res.data.msg);
  });
};

// 字符串转16进制
export function stringToHex(str) {
  if (str === '') return '';
  let hexCharCode = [];
  // hexCharCode.push('0x');
  for (let i = 0; i < str.length; i++) {
    hexCharCode.push(str.charCodeAt(i).toString(16));
  }
  return hexCharCode.join('');
}

// 字符串转16进制
export function stringToHex2(str) {
  let val = '';
  for (let i = 0; i < str.length; i++) {
    if (val === '') val = str.charCodeAt(i).toString(16);
    else val += ',' + str.charCodeAt(i).toString(16);
  }
  return val;
}

// 随机生成8位字符串
const randomStr = function () {
  return ('0'.repeat(8) + parseInt(Math.pow(2, 40) * Math.random(), 10).toString(32)).slice(-8);
};

/*
 * 使用公钥对随机字符串加密
 */
const rsaEncrpt = (randomKey) => {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(RASKEY);
  const data = encrypt.encrypt(randomKey);
  return data;
};

// AES解密
export function Decrypt(word, rStr) {
  const key = CryptoJS.enc.Utf8.parse(stringToHex(rStr));
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    // iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

// AES加密
export function Encrypt(word, rStr) {
  const key = CryptoJS.enc.Utf8.parse(stringToHex(rStr));
  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    // iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
}

export { rsaEncrpt, randomStr };



// WEBPACK FOOTER //
// ./src/utils/utils.js